import styled from 'styled-components'
import { Box as MuiBox, IconButton } from '@material-ui/core'

export const Box = MuiBox

export const MainBox = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const TabContentBox = styled(Box)`
  width: 100%;
  height: 100%;
  margin-top: 1rem;
`

export const TitleSection = styled.section`
  display: flex;
  justify-content: space-between;
`

export const TitleH1 = styled.h1`
  font-family: Jubilat;
  font-style: italic;
  font-weight: 600;
  font-size: 28px;
  letter-spacing: -0.5px;
  text-transform: uppercase;
`

export const BackButton = styled(IconButton)`
  && {
    padding: 6px;
    margin-right: 12px;
    color: #333;
    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
`
